export const CustomerBlackListError = {
    authError : "ログインが必要です",

};


// WEBPACK FOOTER //
// ./src/config/view_const/customer_black_list.ts